import { Divider, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import Close from '@mui/icons-material/Close';

import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { CleanHands, Clear, ClearAll, ClearAllOutlined, ClearOutlined, ClearRounded, Delete } from "@mui/icons-material";

const WarehouseMasterMenu = ({ selectedButtonName, setSelectedButtonName, handlecallProcess, enableRejectParentRoll, title, callback, saveButtonDisabled, visibleDelete, header }) => {

    const [selectedButton, setSelectedButton] = useState(null);
    const [viewParentRollDetail, setViewParentRollDetail] = useState(false);
    const isUpdate = header === 1;

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        setSelectedButtonName(buttonName);

        handlecallProcess(buttonName);

        if (buttonName === 'PDF') {
            setViewParentRollDetail(true);
        }
        else if (buttonName === 'ViewParentRollDetail') {
            setViewParentRollDetail(false);
        }

        if (buttonName == 'QRCode' && viewParentRollDetail === false) {
            setViewParentRollDetail(true);
        }

    };
    return (


        <Grid container justifyContent="space-between" alignItems="center" padding={0}>
            {/* Left-aligned: Edit Employee */}
            <Grid item>
                <Typography variant="h4" sx={{ textAlign: "center", width: "100%", marginLeft: "10px", alignItems: "center" }}>
                    {title === 0 ? 'New Warehouse' : 'Edit Warehouse'}
                </Typography>
            </Grid>

            {/* Right-aligned: Buttons */}
            <Grid item>
                <Grid container alignItems="center">
                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                    {/* Save */}
                    <Grid item ml={1} mr={1}>
                        <Tooltip title={isUpdate ? "Update warehouse" : "Add new warehouse"}>
                            <IconButton
                                onClick={() => handleButtonClick('save')}
                                sx={{ display: 'flex', alignItems: 'center' }}
                                type="submit"
                                disabled={saveButtonDisabled}
                            >
                                <SaveAltIcon style={{ fontSize: "18px", color: selectedButton === 'save' ? "yellow" : "#009688" }} />
                                <Typography variant="body2" sx={{ ml: 1 }}>
                                    {isUpdate ? "Update" : "Save"}
                                </Typography>
                            </IconButton>
                        </Tooltip>
                    </Grid>


                    {visibleDelete && (
                        <>
                            <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                            <Grid item ml={1} mr={1}>
                                <Tooltip title="Delete Warehouse">
                                    <IconButton
                                        onClick={() => handleButtonClick('delete')}
                                        sx={{ display: 'flex', alignItems: 'center' }}

                                    >
                                        <Delete style={{ fontSize: "18px", color: '#e53a1cff' }} />
                                        <Typography variant="body2" sx={{ ml: 1 }}>Delete</Typography>
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </>
                    )}
                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                    {/* Exit Employee */}
                    <Grid item ml={1} mr={1}>
                        <Tooltip title="Clear Warehouse Details">
                            <IconButton
                                onClick={() => handleButtonClick('clear')}
                                sx={{ display: 'flex', alignItems: 'center' }}
                            >
                                <ClearAll style={{ fontSize: "18px", color: "#e0d620ff" }} />
                                <Typography variant="body2" sx={{ ml: 1 }}>Clear</Typography>
                            </IconButton>
                        </Tooltip>
                    </Grid>

                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                    <IconButton onClick={callback}>
                        <Close style={{ fontSize: "14px", color: "#2196F3" }} />
                    </IconButton>
                    <Divider orientation="vertical" flexItem
                    // sx={{ mx: 1 }} 
                    />
                </Grid>
            </Grid>
        </Grid>


    )
};
export default WarehouseMasterMenu;